import type { StoreJsonResponse } from "@/stores/common/store.core";
import { Store } from "@/stores/common/store.core";
import type { GetProjectCategoriesForTieredSelectResponse } from "@laborchart-modules/lc-core-api/dist/api/categories/get-project-categories-for-tiered-select";
import type { ProjectCategory } from "@/react/components/tearsheets/project/categories/types";
import type { ResponsePayload } from "@laborchart-modules/common/dist/api";
import { HttpMethod } from "@/lib/utils/http-methods";
import type { DeleteResponsePayload } from "@laborchart-modules/lc-core-api";

export abstract class CategoriesStore extends Store {
   private static readonly baseUrl = "/api/v3/projects";

   static getProjectCategoriesForTieredSelect(
      projectId: string,
   ): StoreJsonResponse<GetProjectCategoriesForTieredSelectResponse> {
      return this.requestJson({
         url: `${this.baseUrl}/${projectId}/categories/tiered-select`,
         method: HttpMethod.GET,
      });
   }

   static getProjectCategories(
      projectId: string,
   ): StoreJsonResponse<ResponsePayload<ProjectCategory[]>> {
      return this.requestJson({
         url: `${this.baseUrl}/${projectId}/categories`,
         method: HttpMethod.GET,
      });
   }

   static createProjectCategory(
      projectId: string,
      payload: Pick<ProjectCategory, "name" | "parent_id">,
   ): StoreJsonResponse<ResponsePayload<ProjectCategory>> {
      return this.requestJson({
         url: `${this.baseUrl}/${projectId}/categories/manage`,
         method: HttpMethod.POST,
         body: payload,
      });
   }

   static updateProjectCategory(
      projectId: string,
      id: string,
      payload: { name?: string; sequence?: number; parent_id?: string | null; project_id?: string },
   ): StoreJsonResponse<ResponsePayload<ProjectCategory>> {
      return this.requestJson({
         url: `${this.baseUrl}/${projectId}/categories/${id}/manage`,
         method: HttpMethod.PATCH,
         body: payload,
      });
   }

   static deleteProjectCategory(
      projectId: string,
      id: string,
   ): StoreJsonResponse<ResponsePayload<DeleteResponsePayload>> {
      return this.requestJson({
         url: `${this.baseUrl}/${projectId}/categories/${id}/manage`,
         method: HttpMethod.DELETE,
      });
   }
}
